import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcStar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.693 3.123a1.465 1.465 0 0 1 1.945-.652l.008.004c.285.142.512.37.655.655l.002.004 2.252 4.564c.052.108.14.17.248.185h.007l5.032.75.029.006c.765.132 1.325.84 1.2 1.65l-.002.017-.003.017c-.057.281-.191.559-.415.783l-.007.007-3.63 3.54a.38.38 0 0 0-.105.316l.862 5.02c.125.789-.412 1.519-1.18 1.663a1.46 1.46 0 0 1-.926-.136l-.007-.003-4.507-2.374-.003-.001a.33.33 0 0 0-.316 0l-.002.001-4.507 2.374-.007.003c-.257.129-.512.16-.716.16h-.029l-.028-.003a1.44 1.44 0 0 1-.744-.27 1.5 1.5 0 0 1-.491-.629l-.014-.033-.01-.035a1.6 1.6 0 0 1-.065-.724l.002-.013.86-5.007v-.001a.34.34 0 0 0-.09-.305l-.005-.003-3.646-3.557a1.46 1.46 0 0 1-.033-2.037c.238-.271.56-.407.849-.446l5.026-.73h.002a.36.36 0 0 0 .255-.191V7.69zm1.302.75L9.781 8.362c-.265.53-.78.92-1.384 1.007l-4.945.718 3.58 3.491c.448.432.626 1.045.528 1.632v.004l-.846 4.925 4.414-2.325h.002a1.83 1.83 0 0 1 1.72 0h.002l4.424 2.33-.845-4.92c-.103-.601.105-1.198.508-1.617l.009-.009 3.583-3.494-4.938-.735a1.82 1.82 0 0 1-1.386-1.013z",
    clipRule: "evenodd"
  }));
}
var IcStar = createNolIcon(/*#__PURE__*/forwardRef(SvgIcStar));

export { IcStar as I };
